export default __webpack_public_path__ + "static/media/laundry1-afterA-1440w.4a7a05b1.avif";